import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { requestsStateEnum, requestsResultEnum } from '@modules/hr-requests/_requestsEnums';

export default [
  {
    label: 'Žadatel',
    field: 'assigner.fullName',
    displayField: 'assigner',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Schvalovatel',
    field: 'approver.fullName',
    displayField: 'approver',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Dovolená od',
    field: 'from',
    type: ColumnType.DATETIME,
    width: 200
  },
  {
    label: 'Dovolená do',
    field: 'to',
    type: ColumnType.DATETIME,
    width: 200
  },
  {
    label: 'Stav',
    field: 'state',
    type: ColumnType.ENUM,
    enum: requestsStateEnum,
    width: 200
  },
  {
    label: 'Výsledek',
    field: 'result',
    type: ColumnType.ENUM,
    enum: requestsResultEnum,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-requests/holidays/_requestsHolidayColumns.ts